var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.91667V5.08334C14.1667 4.61663 14.1667 4.38327 14.0758 4.20501C13.9959 4.04821 13.8685 3.92073 13.7117 3.84083C13.5334 3.75001 13.3001 3.75001 12.8333 3.75001H2.5M10.8333 12.0833V14.9167C10.8333 15.3834 10.8333 15.6168 10.7425 15.795C10.6626 15.9518 10.5352 16.0793 10.3783 16.1592C10.2001 16.25 9.96675 16.25 9.5 16.25H2.5M2.5 1.66667V18.3333M2.5 12.0833H16.1667C16.6334 12.0833 16.8668 12.0833 17.045 11.9925C17.2018 11.9126 17.3293 11.7852 17.4092 11.6283C17.5 11.4501 17.5 11.2168 17.5 10.75V9.25001C17.5 8.78326 17.5 8.54992 17.4092 8.37167C17.3293 8.21488 17.2018 8.0874 17.045 8.0075C16.8668 7.91667 16.6334 7.91667 16.1667 7.91667H2.5V12.0833Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.2d0148ae708c361749bc31e0237344a6.svg";
export { ForwardRef as ReactComponent };